// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__14uOX","colMaxWidth":"Table_colMaxWidth__-RFUd"};